<script setup>
import Multiselect from "vue-multiselect";
import {computed} from "vue";

const props = defineProps(['value', 'name', 'options']);
const emit = defineEmits(['input', 'updateOptions']);

const model = computed({
    get: () => props.value,
    set: (value) => emit('input', value),
})

</script>

<template>
    <div class="form__item">
        <label class="form__label">{{ name }}</label>

        <Multiselect
            v-model="model"
            :multiple="true"
            :placeholder="`Select ${name}`"
            :options="options"
            select-label=""
            deselect-label=""
            label="name"
            track-by="name"
            class="multiselect-mid multiselect-modern"
            @search-change="(query) => emit('updateOptions', query)"
        />
    </div>
</template>

<style scoped>
    .form__label {
        text-transform: capitalize;
    }
</style>
